module.exports = __webpack_public_path__ + "static/media/imageskybanner-1.7e6c5029.jpeg";